import { Box, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import NirantaraIcon from "../assets/images/vajra.svg";
import { getConsultantIconUrl } from "../utils/consultantLogo";
import {
  miniSidebarElements,
  sidebarElements1,
  sidebarElementsFacility,
} from "../utils/constant";
import wateroverview from "../assets/images/Sidebar/wateroverview.svg";
import waterdata from "../assets/images/Sidebar/waterdata.svg";
import SidebarItemsRenderer from "../utils/layoutFunctions";
import { useUser } from "../context/AuthContext";
import {
  filterMiniSidebarElements,
  getRoleBasedSidebar,
} from "../utils/sidebarFunctions";

const WaterManagement = () => {
  const location = useLocation();
  const { user } = useUser();

  const [isHovered, setIsHovered] = useState(false);

  const mastersSidebarElements = [
    {
      text: "Dashboard",
      icon: wateroverview,
      path: "/water-management/dash-board",
    },
    {
      text: "Data",
      icon: waterdata,
      path: "/water-management/data",
    },
  ];

  const sidebarElements = getRoleBasedSidebar({
    user,
    sidebarElements1,
    sidebarElementsFacility,
  });

  const filteredSidebar = sidebarElements.map((item) => {
    if (item.path === "/production-revenue") {
      return {
        ...item,
        heading: user?.companyAdmin ? "Production & Revenue" : "Production",
      };
    }
    if (item.heading === "Setup" && item.subData) {
      const newSubData = item.subData.filter(
        (sub) => sub.primary !== "Facility Master" || !user?.facility
      );
      return { ...item, subData: newSubData };
    }
    return item;
  });

  const miniSidebarFiltered = filterMiniSidebarElements({
    user,
    miniSidebarElements,
  });

  const renderMainSidebarItems = (elements) => {
    return elements.map((item, index) => (
      <div
        key={index}
        style={{
          fontFamily: "Inter",
          display: "flex",
          flexDirection: "column",
          marginTop: "0.25rem",
        }}
      >
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor:
              item.primary === "Scope 1" ? "#488257" : "transparent",
          }}
        >
          <Tooltip
            title={item.title}
            arrow
            placement="bottom-start"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 0],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  color: "#fff",
                  fontSize: "12px",
                  borderRadius: "4px",
                  padding: "0.25rem 0.5rem",
                },
                arrow: {
                  color: "#fff",
                },
              },
            }}
          >
            <a
              href={item.path}
              key={item.primary}
              style={{
                textDecoration: "none",
                color: "green",
                padding: "0.4rem",
                borderRadius: "4px",
              }}
            >
              <Box
                component="img"
                src={item.icon}
                alt={"img"}
                sx={{
                  width: "24px",
                  height: "24px",
                  // filter: location.pathname.startsWith(
                  //   item.path.match(/^\/[^/]+/)[0]
                  // )
                  //   ? "invert(1)"
                  //   : "invert(0)",
                }}
              />
            </a>
          </Tooltip>
        </div>
      </div>
    ));
  };

  const renderSecondarySidebarItems = (elements, heading) => {
    return (
      <div style={{ width: "100%", fontFamily: "Inter", marginTop: "1.5rem" }}>
        {heading && (
          <p
            style={{
              color: "#fff",
              fontWeight: "700",
              fontSize: "24px",
              padding: "0 2rem 0 0.5rem",
              marginLeft: "1rem",
              borderBottom: "2px solid #fff",
              display: "inline-block",
            }}
          >
            {heading}
          </p>
        )}
        {elements.map((item, index) => (
          <div key={`item-${index}`}>
            <Link
              to={item.path}
              style={{
                textDecoration: "none",
                color: location.pathname.includes(item.path)
                  ? "#488257"
                  : "#ffffff",
                display: "flex",
                padding: "0.5rem",
                margin: "4px 8px",
                backgroundColor: location.pathname.includes(item.path)
                  ? "#ffffff"
                  : "",
                borderRadius: "4px",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Box
                component="img"
                src={item.icon}
                alt={"img"}
                sx={{
                  filter:
                    location.pathname === item.path
                      ? "invert(0)"
                      : "invert(1) grayscale(1) brightness(1000%)",
                }}
              />
              <span
                style={{
                  marginLeft: "1rem",
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "inherit",
                }}
              >
                {item.text}
              </span>
            </Link>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <Box style={{ display: "flex" }}>
        <div
          style={{
            width: "22.5%",
            backgroundColor: "#E6E6E6",
            height: "100vh",
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Box display="flex" justifyContent="center" p={2}>
            <img
              src={getConsultantIconUrl() || NirantaraIcon}
              alt="Nirantara Logo"
              style={
                getConsultantIconUrl()
                  ? { cursor: "pointer", height: "36px", width: "36px", objectFit: "contain" }
                  : { cursor: "pointer", height: "44px", width: "auto", objectFit: "contain" }
              }
            />
          </Box>
          <div style={{ width: "100%", marginTop: "1rem" }}>
            {renderMainSidebarItems(miniSidebarFiltered)}
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "21.3vw",
              height: "100vh",
              backgroundColor: "#fff",
              zIndex: 10,
              overflowY: "auto",
              transform: isHovered ? "translateX(0)" : "translateX(-100%)",
              opacity: isHovered ? 1 : 0,
              transition: "opacity 0.4s ease, transform 0.4s ease",
              pointerEvents: isHovered ? "auto" : "none",
              willChange: "transform, opacity",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {<SidebarItemsRenderer elements={filteredSidebar} />}
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#488257",
            width: "77.5%",
          }}
        >
          {renderSecondarySidebarItems(
            mastersSidebarElements,
            "Water Management"
          )}
        </div>
      </Box>
    </>
  );
};

export default WaterManagement;
